<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import flexible from '../static/js/flexible'
import {getParamStr, getURLParams, configPlatformObj, configUrl, getPathName} from '../static/js/public'
export default {
	name: 'app',
	data() {
		return {}
	},
	created() {

		/*** add by huangqb: 判断是否Alexa还是Google ***/
		//设置全局变量的信息
		window.platformBL = this.getPlatform();
		//页面路径
        var _pathName = getPathName();
        //页面参数
        var _params = getURLParams() || {};
		/*** end ***/

		//根据页面的路径判断页面的指向
		var _pravicy = _params["privacy"] || _params["blprivacys"];
		if(!!_pravicy) {
			this.$router.replace({
	            path: _pathName + '/privacy',
	            query: _params
	        });
			return;
		} else if(_params["blservice"]) {
			this.$router.replace({
	            path: _pathName + '/serviceTerm',
	            query: _params
	        });
			return;
		}

		//取得页面的参数，用于进行h5路由设置
		var pageParam = _params["blpage"];
		switch(pageParam) {
			case "login":
				this.$router.push({
					path: _pathName + '/login',
	            	query: _params
				});
				break;
			case "privacy":
				this.$router.push({
					path: _pathName + '/privacy'
				});
				break;
			case "service":
				this.$router.push({
					path: _pathName + '/serviceTerm'
				});
				break;
			default:
				break;
		}
	},
	methods: {
		/**
		 * 获取平台信息
		 * @return {[type]} [description]
		 */
		getPlatform() {
			let host = window.location.search;
			for(var keysObj in configUrl) {
				
				for(var keys in configUrl[keysObj]) {

					if(host && host.indexOf(configUrl[keysObj][keys].client_id) >= 0) {
						return keysObj;
					}
				}
			}
			//默认的值
			return "alexa";
		}
	}
}

</script>

<style lang="scss">

@import '../static/css/normalize.css';
@import '../static/css/common.scss';

#app {
	position: relative;
	font-family: 'PingFangSC', 'arial', Helvetica, sans-serif, 'Microsoft YaHei';
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	padding: pxtorem(20) pxtorem(24);
	margin: pxtorem(36) auto 0 auto;
	max-width: pxtorem(648);
	min-height: pxtorem(1000);
	background-color: #fff;
	border-radius: 4px;
	border: solid 1px #dedee1;
	box-shadow: 0 0 10px 3px #dedee1;
}

.footer {
	position: absolute;
	left: 0;
	right: 0;
	bottom: pxtorem(-110);
	margin: 0 auto;
	padding-bottom: pxtorem(50);
	@include font-dpr(16);

	.ftext {
		padding: 0 pxtorem(40);
		display: inline-block;
		color: #009fe1;
	}

	a {
		border-right: pxtorem(2) solid #dedee1;
	}
	
	a:last-child {
		border-right: 0;
	}

}
</style>



// WEBPACK FOOTER //
// src/App.vue